import React from "react";

export const SurveyStatusBadge = ({ value }) => (
  <span className={`survey-engine-status ${value || "draft"}`}>{value || "draft"}</span>
);

export const SurveyRewardStatusBadge = ({ value }) => {
  const status = value || "not_applicable";
  return <span className={`survey-engine-reward-status ${status}`}>{status.replace("_", " ")}</span>;
};
